import {basicRepositoryFactory, basicPublisher, WorkerConfig} from './publisher.js';
import {conflateRepo} from './common.js';
import * as core from './core.js';
import {IOGateway} from '../../gateway';

export type RestConfig = IOGateway.RestMetricsPublisherConfig & WorkerConfig

export async function restPublisher(config?: RestConfig) {
    const conflationMaxCount = config?.conflation?.["max-datapoints-repo"] ?? 50;
    return await basicPublisher<RestConfig>(
        config,
        (data) => conflateRepo(conflationMaxCount, data),
        config?.publishFn ?? '@interopio/gateway/metrics/publisher/rest'
    );
}

export async function restRepositoryFactory(config?: RestConfig): Promise<core.RepositoryFactory> {
    return basicRepositoryFactory(config, await restPublisher(config));
}
